import React from 'react';
import { LinkElement } from '@els/els-react--link-element';
import { QUICK_SEARCH_TRACKING_BUTTON_TYPES, trackQuickSearchButtonClick } from '../analytics';

import './BuildQueryContentInfo.scss';

const INTEGRATED_DATABASES_LINK = 'https://www.elsevier.support/reaxys/answer/which-databases-are-integrated-in-reaxys';

function BuildQueryContentInfo() {
  return (
    <section className="build-query-content-info u-els-margin-bottom-3x" aria-labelledby="build-query-content-info-heading">
      <h3
        id="build-query-content-info-heading"
        className="build-query-content-info__title u-els-margin-bottom-1o2 u-els-font-size-h4 u-els-font-family-bold">
        Accelerate chemistry research with trusted data
      </h3>
      <p className="build-query-content-info__description u-els-font-size-h4">
        Find reactions, substances, literature, bioactivity data and commercial suppliers with our powerful{' '}
        <LinkElement
          inline
          isExternal
          noExternalIcon
          iconSprite="UpRight"
          iconSize="xs"
          iconRight
          iconEmphasis
          data-e2e="e2e-build-query-heading-integrated-database"
          onClick={() => {
            trackQuickSearchButtonClick(QUICK_SEARCH_TRACKING_BUTTON_TYPES.integratedDatabases);
          }}
          href={INTEGRATED_DATABASES_LINK}>
          integrated databases
        </LinkElement>
      </p>
    </section>
  );
}

export default BuildQueryContentInfo;
